import React, { useState, useEffect } from "react";
import Sectionone from "./Section/Sectionone";
import Sectiontwo from "./Section/Sectiontwo";
import OurPartners from "./Section/OurPartners";
import OurExpertise from "./Section/OurExpertise";
import IndustryCategories from "./Section/IndustryCategories";
import ImpactNumbers from "./Section/ImpactNumbers";
import NewsItems from "./Section/newsItems";
import GetInTouch from "./Section/GetInTouch";
import NewsData from "./Section/newsData";
import OurExpertisedata from "./Section/OurExpertisedata";
import CookiesPopup from "./CookiesPopup";
import { Helmet } from "react-helmet-async";
import Videobox from "../components/Section/HomeVideobox";

function Home() {
  const [showCookiesPopup, setShowCookiesPopup] = useState(false);

  useEffect(() => {
    const timer = setTimeout(() => {
      setShowCookiesPopup(true);
    }, 5000);
    return () => clearTimeout(timer);
  }, []);

  const handleAcceptCookies = () => setShowCookiesPopup(false);
  const handleDenyCookies = () => setShowCookiesPopup(false);

  return (
    <div className="bg-[#0C2341]">
      <Helmet>
        <title>Arabian Karim Trading Co: Home</title>

        <meta name="description" content="AKT Corp works with a concentrated set of leading suppliers bringing the best materials to our client's business needs. AKT Corp recognizes the need to support clients with high-quality products and marketing support." />

        <meta name="keywords" content="AKT Corp, Arabian Karim Trading Co. LLC, AKT Trading, AKT Corporation, Industrial Solutions, Industrial Equipment Suppliers, Building Materials Supplier, Offshore Industry Supplies, Oil & Gas Industry Supplies, Steel Solutions Supplier, Fiber Optics Solutions, Advanced Silicone Products, Industrial Lubricants Supplier, Fire-Rated Components, Thermal Insulation Solutions, Heavy Equipment Supplies, Electronics Industry Materials, Personal Care & Healthcare Solutions, Saudi Aramco Supplier, MARAFIQ Industrial Solutions, Saudi Arabia Railways Co Supplies, Petro Rabigh Industrial Products, Herkula Partner, Livesmart Partner, Momentive Products Supplier, Fenzi Industrial Solutions, Reliable Industrial Supplies, High-Quality Industrial Equipment, Heavy Machinery Lubricants, Advanced Sealing & Adhesives, Manufacturing Materials Supplier, Construction Materials Supplier, Electrical Components Supplier, Industrial Chemicals & Coatings, Request a Quote AKT Corp, Industrial Supplier in Saudi Arabia, Contact AKT Corp, Buy Industrial Materials Online, Fast & Reliable Industrial Supplies, Customized Industrial Solutions" />
      </Helmet>


      <Sectionone />



      <Sectiontwo />



      <OurPartners />



      <OurExpertise />



      <OurExpertisedata />



      <Videobox />



      <IndustryCategories />



      <ImpactNumbers />



      <NewsItems />



      <NewsData />



      <GetInTouch />


      {showCookiesPopup && (
        <CookiesPopup onAccept={handleAcceptCookies} onDeny={handleDenyCookies} />
      )}

    </div>
  );
}

export default Home;
